<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item label="付款单号：">
                <el-input v-model.trim="searchForm.orderNo" @keyup.enter.native="getRecorListHandler" clearable></el-input>
            </el-form-item> 
            <el-form-item label="第三方单号：">
                <el-input v-model.trim="searchForm.payOrder" @keyup.enter.native="getRecorListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getRecorListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="套餐组系列："> 
                <el-select v-model="searchForm.pkgGroupId" clearable filterable>
                    <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
			<el-form-item label="充值日期：" >
			    <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
			</el-form-item>
            <el-form-item label="支付状态：">
                <el-select v-model="searchForm.payState" clearable>
                    <el-option label="已退款" value="3"></el-option>
                    <el-option label="退款中" value="2"></el-option>
                    <el-option label="已支付" value="1"></el-option>
                    <el-option label="未支付" value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getRecorListHandler">搜索查询</el-button>
                <el-button type="success" plainicon="el-icon-s-ticket"  @click="showBatchChgStateHandler12()">批量导入优惠券</el-button>
                 <el-button type="success"  @click="exportSimInfoHandle" plain icon="el-icon-download">导出Excel</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >
            <el-table-column type="index"  align="center" label="序号"></el-table-column> 
            <el-table-column prop="orderNo"  align="center" label="付款单号"></el-table-column>   
            <el-table-column prop="payOrder" label="第三方单号"></el-table-column>    
            <el-table-column label="ICCID号"  align="center" >
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToUserBalance(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column  align="center"  label="付款金额 （元）" width="120">
                <template slot-scope="scope">
                    {{scope.row.amount/100}}
                </template>
            </el-table-column>
            <el-table-column  align="center"  label="赠送金额 （元）" width="120">
                <template slot-scope="scope">
                    {{scope.row.giftBalance/100}}
                </template>
            </el-table-column>
            <el-table-column   align="center" label="支付类型" width="120">
                <template slot-scope="scope">
                     {{scope.row.payTypeName}}
                </template>
            </el-table-column>

            <el-table-column  align="center"  label="商户号" width="100">
                <template slot-scope="scope">
                     {{scope.row.subId}}
                </template>
            </el-table-column>

            <el-table-column  align="center"  label="支付状态" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.payState==1" style="color:green">已支付</span>
                    <span v-else-if="scope.row.payState==2" style="color:blue">退款中</span>
                    <span v-else-if="scope.row.payState==3" style="color:green">已退款</span>
                    <span v-else-if="scope.row.payState==-1" style="color:red">订单不存在</span>
                    <span v-else-if="scope.row.payState==0" style="color:red">未支付</span>
                    <span v-else  style="color:red">未知状态</span>
                </template>
            </el-table-column>

            <el-table-column  align="center" prop="createTime" label="付款时间" width="160"></el-table-column>

            <el-table-column  align="center"  label="操作" width="240">
                <template v-slot="scope">
                    <el-button type="text" size="small" v-if="scope.row.payState==1" @click="showRefundDialog(scope.row)">申请退款</el-button>
                    <el-button type="text" size="small"    @click="investOrder(scope.row.orderNo)">过期赠送金</el-button>
                    <el-button type="text" size="small"    @click="investOrder1(scope.row.orderNo)">转赠送金</el-button>
                </template>
            </el-table-column>

        </el-table>
        
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>

        <el-dialog :append-to-body="true"  title="转赠送金" :visible.sync="transferBalanceVisible" width="600px" @close="closeTransferBalanceDialog()" :close-on-click-modal="false">
            <el-form ref="transferBalanceForm" :model="transferBalanceForm"  label-width="120px">
               <el-form-item label="转入卡ICCID：" prop="iccid">
                    <el-input v-model.trim="transferBalanceForm.iccid" placeholder="转入卡ICCID/或者虚拟号" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeTransferBalanceDialog()">取 消</el-button>
                <el-button type="primary" @click="investOrder2()">确 定</el-button>
            </div> 
        </el-dialog> 

        <el-dialog :append-to-body="true"  title="退款申请" :visible.sync="refundDialogVisible" width="600px" :close-on-click-modal="false" @close="cancelRefund()">

            <el-form ref="refundForm" :model="refundForm" :rules="refundRules" label-width="140px">
                <el-form-item label="付款单号：" >
                    <span>{{refundForm.orderNo}}</span>
                </el-form-item>

                <el-form-item label="退款金额(元)：" prop="priceRmb">
                    <el-input-number v-model="refundForm.priceRmb" :precision="2" :step="1" :min="0" :max="maxPriceRmb" clearable></el-input-number>
                </el-form-item>

                <el-form-item label="退款原因：" >
                    <el-input v-model="refundForm.rqReason" type="textarea"  maxlength="50" clearable></el-input>
                </el-form-item>

                <el-form-item label="凭证截图：" >
                    <el-upload class="avatar-uploader" action=""
                        :show-file-list="false"
                        :auto-upload="false"
                        :on-change="handleAvatarSuccess">
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-form>   
            <p style="color:red">确定后 会立即退回用户，并且所有赠送金失效</p>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelRefund()">取 消</el-button>
                <el-button type="primary" @click="applyRefundUser()">确 定</el-button>
            </div>       

        </el-dialog>

         <el-dialog :append-to-body="true"  title="批量添加优惠券" :visible.sync="batchOptVisible12" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="searchForm" :model="searchForm"   label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel"> 
                    <el-upload ref="upload" :action="uploadUrl('import/sim/state/insert/price/excel')" :headers="setHeader()" :auto-upload="false" :data="batchOptForm" :on-change="handleChange" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="downPdf()">导入模板</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler12">确 定</el-button>
            </div> 
        </el-dialog>      
                 
    </div>
</template>
<script>
import {getBalanceRechargeRecordLists} from '@/api/record.js'
import {simPriceOrderList} from '@/api/user.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            transferBalanceVisible:false,
            transferBalanceForm:{
                iccid:'',
                 orderNo: '',

            },
            searchForm: {
                iccid: '',
                orderNo: '',
                payOrder: null,
                payState:null,
				time: '',
                pkgGroupId:''

            },
            pkgGroup: [],
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },

            refundDialogVisible: false,
            refundForm:{
                orderNo: '',
                priceRmb: '',
                remark: '',
                rqReason:'',
                file: null,
            },
            maxPriceRmb:0,
            batchOptVisible12:false,
            imageUrl: '',

            refundRules:{
                priceRmb: { required: true, message: '必填项', trigger: 'blur' },
            }
            
        }
    },
    methods: {
          exportSimInfoHandle(){//导出excel文件
            this.$confirm("您确定要导出列表吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {

                 common.deleteSpaceKey(this.searchForm); 
                simPriceOrderList(this.searchForm).then(res =>{
                    if(res.data.code == 200){
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    }else{
                        this.$message.error(res.data.msg);
                    }
                }).catch(err=>console.error(err)); 
            })          
        },
         sureBatchChgStateHandler12(){ 
            this.$refs.searchForm.validate(valid => {
                if(valid) {           
                    this.$refs.upload.submit();
                }
                this.batchOptVisible12=false;
                 this.$message.success('导入成功！');
               this.getRecorListHandler();

            });

        },
         downPdf(){
            var link = document.createElement('a');
                link.setAttribute('download', '');
                link.href = '../../../doc/添加优惠券模板.xls';
                link.click();
        },
          showBatchChgStateHandler12(){
            this.batchOptVisible12 = true;
        },
         cancel(){
               this.batchOptVisible12 = false;
        },
         handleSuccess(res){
            if(res.code == 200){
                this.batchOptVisible12 = false;
                this.getRecorListHandler();
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
        },
         showBatchChgStateHandler12(){
            this.batchOptVisible12 = true;
        },
        closeTransferBalanceDialog(){
            this.transferBalanceVisible=false;
        },
        getRecorListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);   
            getBalanceRechargeRecordLists(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })    
        },

        goToUserBalance(row){
            this.$store.commit('menu/setFromPage', 'balanceRechargeRecord');
            this.$store.commit('menu/setIccidToAccount', row.iccid);
            document.getElementById('userBalanceMenu').click();
        },

      
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getRecorListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getRecorListHandler();
        },


        showRefundDialog(data){
            this.refundForm.orderNo = data.orderNo;
            if(data.giftBalance){
                this.maxPriceRmb = (data.amount + data.giftBalance)/100;
            }else{
                this.maxPriceRmb = data.amount/100;
            }
            
            this.refundDialogVisible = true;
        },

        handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(res.raw);
            this.refundForm.file = res.raw;
        },

        beforeAvatarUpload(file) {
            if(file){
                let isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
                let isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                  this.$message.error('上传的图片只能是 JPG 或 PNG 格式!');
                }
                if (!isLt2M) {
                  this.$message.error('上传的图片大小不能超过 2MB!');
                }
                this.refundForm.file = file;
                return isJPG && isLt2M;
            }
            
            return true;
        }, 

        cancelRefund(){
            this.refundForm.priceRmb = '',
            this.refundForm.remark = '',
            this.refundForm.file = null;
            this.imageUrl = null;
            this.refundDialogVisible = false;
        },

        applyRefundUser(){
            if(this.refundForm.priceRmb == 0){
                this.$message.error("退款金额不能为0");
                return;
            }
            this.$refs.refundForm.validate(valid => {
                if(valid) {
                    if(this.beforeAvatarUpload(this.refundForm.file)){
                        let formData = new FormData();
                        Object.keys(this.refundForm).forEach((key) => {
                            formData.append(key, this.refundForm[key]);
                        });
                        common.sysRequest('order/applyRefundUsers', formData, 'post').then(res => {
                            if(res.data.code == 200){
                                this.$message.success(res.data.message);
                                this.cancelRefund();
                                this.getRecorListHandler();
                            }else{
                               this.$message.error(res.data.message); 
                            }
                        })
                    }
                }
            })
        },

        investOrder(orderNo){

              this.$confirm("您确定要过期这个订单的赠送金嘛？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {
                common.sysRequest('order/applyRefundUsers/expri', {'orderNo':orderNo}, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    this.getRecorListHandler();
                }else{
                   this.$message.error(res.data.message); 
                }
            })
            })

           
        },
         investOrder1(orderNo){

              this.transferBalanceForm.orderNo=orderNo;
              this.transferBalanceVisible=true;

           
        },
        investOrder2(){
              this.$confirm("您确定要转移这个订单的赠送金嘛？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {
                common.sysRequest('order/applyRefundUsers/change',this.transferBalanceForm, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                      this.transferBalanceVisible=false;
                    this.getRecorListHandler();
                }else{
                   this.$message.error(res.data.message); 
                }
            })
            })

           
        },
        
    },
    created () {
        common.getPkgGroupListCom(this, 'pkgGroup');
    },

    mounted () {
       
        let fromPage = this.$store.state.menu.fromPage;
        let fromPageOrderNo = this.$store.state.menu.fromPageOrderNo;
        if(fromPage == 'userAccountFlowRecord'){
            this.searchForm.orderNo = fromPageOrderNo;
            this.getRecorListHandler();
            this.$store.commit('menu/setFromPage', '');
            this.$store.commit('menu/setFromPageOrderNo', '');
        }
        else{
            this.getRecorListHandler();
        }

        
    },

    computed:{
        fromPageOrderNo: function(){
            return this.$store.state.menu.fromPageOrderNo;
        },
    },

    watch: {
        fromPageOrderNo: function () {
            let fromPage = this.$store.state.menu.fromPage;
            let fromPageOrderNo = this.$store.state.menu.fromPageOrderNo;
            if(fromPage == 'userAccountFlowRecord'){
                this.searchForm.orderNo = fromPageOrderNo;
                this.getRecorListHandler();
                this.$store.commit('menu/setFromPage', '');
                this.$store.commit('menu/setFromPageOrderNo', '');
            }
        }
    },
}
</script>
<style lang="less" scoped>
    el-upload {
        border: 1px dashed #d9d9d9;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
        border: 1px dashed #d9d9d9;
    }
</style>

